/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CotisationsBelgesHorsZoneIcDto } from '../models/cotisations-belges-hors-zone-ic-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des cotisations des Belges hors zone IC
 */
@Injectable({
  providedIn: 'root',
})
export class CotisationsBelgesHorsZoneIcService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation cotisationsBelgesHorsZoneIcGetList
   */
  static readonly CotisationsBelgesHorsZoneIcGetListPath = '/api/cotisations-belges-hors-zone-ic/list/{belgeId}';

  /**
   * Renvoie la liste des cotisations du Belge hors zone IC spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsBelgesHorsZoneIcGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  cotisationsBelgesHorsZoneIcGetList$Response(params: {

    /**
     * Identifiant du Belge
     */
    belgeId: number;
  }): Observable<StrictHttpResponse<Array<CotisationsBelgesHorsZoneIcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsBelgesHorsZoneIcService.CotisationsBelgesHorsZoneIcGetListPath, 'get');
    if (params) {
      rb.path('belgeId', params.belgeId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CotisationsBelgesHorsZoneIcDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des cotisations du Belge hors zone IC spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsBelgesHorsZoneIcGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cotisationsBelgesHorsZoneIcGetList(params: {

    /**
     * Identifiant du Belge
     */
    belgeId: number;
  }): Observable<Array<CotisationsBelgesHorsZoneIcDto>> {

    return this.cotisationsBelgesHorsZoneIcGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CotisationsBelgesHorsZoneIcDto>>) => r.body as Array<CotisationsBelgesHorsZoneIcDto>)
    );
  }

  /**
   * Path part for operation cotisationsBelgesHorsZoneIcLoadList
   */
  static readonly CotisationsBelgesHorsZoneIcLoadListPath = '/api/cotisations-belges-hors-zone-ic/load-list/{belgeId}';

  /**
   * Renvoie la liste des cotisations du Belge hors zone IC spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsBelgesHorsZoneIcLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsBelgesHorsZoneIcLoadList$Response(params: {

    /**
     * Identifiant du Belge
     */
    belgeId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsBelgesHorsZoneIcService.CotisationsBelgesHorsZoneIcLoadListPath, 'post');
    if (params) {
      rb.path('belgeId', params.belgeId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des cotisations du Belge hors zone IC spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsBelgesHorsZoneIcLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsBelgesHorsZoneIcLoadList(params: {

    /**
     * Identifiant du Belge
     */
    belgeId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.cotisationsBelgesHorsZoneIcLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation cotisationsBelgesHorsZoneIcGet
   */
  static readonly CotisationsBelgesHorsZoneIcGetPath = '/api/cotisations-belges-hors-zone-ic/{id}';

  /**
   * Renvoie la cotisation d'un Belge hors zone IC spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsBelgesHorsZoneIcGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  cotisationsBelgesHorsZoneIcGet$Response(params: {

    /**
     * Identifiant de la cotisation d&#x27;un Belge hors zone IC spécifiée
     */
    id: number;
  }): Observable<StrictHttpResponse<CotisationsBelgesHorsZoneIcDto>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsBelgesHorsZoneIcService.CotisationsBelgesHorsZoneIcGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CotisationsBelgesHorsZoneIcDto>;
      })
    );
  }

  /**
   * Renvoie la cotisation d'un Belge hors zone IC spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsBelgesHorsZoneIcGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  cotisationsBelgesHorsZoneIcGet(params: {

    /**
     * Identifiant de la cotisation d&#x27;un Belge hors zone IC spécifiée
     */
    id: number;
  }): Observable<CotisationsBelgesHorsZoneIcDto> {

    return this.cotisationsBelgesHorsZoneIcGet$Response(params).pipe(
      map((r: StrictHttpResponse<CotisationsBelgesHorsZoneIcDto>) => r.body as CotisationsBelgesHorsZoneIcDto)
    );
  }

  /**
   * Path part for operation cotisationsBelgesHorsZoneIcPut
   */
  static readonly CotisationsBelgesHorsZoneIcPutPath = '/api/cotisations-belges-hors-zone-ic/{id}';

  /**
   * Met à jour la cotisation d'un Belge hors zone IC spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsBelgesHorsZoneIcPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsBelgesHorsZoneIcPut$Response(params: {

    /**
     * Identifiant de la cotisation d&#x27;un Belge hors zone IC à mettre à jour
     */
    id: number;

    /**
     * Cotisation d'un Belge hors zone IC
     */
    body: CotisationsBelgesHorsZoneIcDto
  }): Observable<StrictHttpResponse<CotisationsBelgesHorsZoneIcDto>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsBelgesHorsZoneIcService.CotisationsBelgesHorsZoneIcPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CotisationsBelgesHorsZoneIcDto>;
      })
    );
  }

  /**
   * Met à jour la cotisation d'un Belge hors zone IC spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsBelgesHorsZoneIcPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsBelgesHorsZoneIcPut(params: {

    /**
     * Identifiant de la cotisation d&#x27;un Belge hors zone IC à mettre à jour
     */
    id: number;

    /**
     * Cotisation d'un Belge hors zone IC
     */
    body: CotisationsBelgesHorsZoneIcDto
  }): Observable<CotisationsBelgesHorsZoneIcDto> {

    return this.cotisationsBelgesHorsZoneIcPut$Response(params).pipe(
      map((r: StrictHttpResponse<CotisationsBelgesHorsZoneIcDto>) => r.body as CotisationsBelgesHorsZoneIcDto)
    );
  }

  /**
   * Path part for operation cotisationsBelgesHorsZoneIcPost
   */
  static readonly CotisationsBelgesHorsZoneIcPostPath = '/api/cotisations-belges-hors-zone-ic/{belgeId}';

  /**
   * Crée la cotisation d'un Belge hors zone IC spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cotisationsBelgesHorsZoneIcPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsBelgesHorsZoneIcPost$Response(params: {

    /**
     * Identifiant du Belge
     */
    belgeId: number;

    /**
     * Cotisation d'un Belge hors zone IC
     */
    body: CotisationsBelgesHorsZoneIcDto
  }): Observable<StrictHttpResponse<CotisationsBelgesHorsZoneIcDto>> {

    const rb = new RequestBuilder(this.rootUrl, CotisationsBelgesHorsZoneIcService.CotisationsBelgesHorsZoneIcPostPath, 'post');
    if (params) {
      rb.path('belgeId', params.belgeId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CotisationsBelgesHorsZoneIcDto>;
      })
    );
  }

  /**
   * Crée la cotisation d'un Belge hors zone IC spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cotisationsBelgesHorsZoneIcPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cotisationsBelgesHorsZoneIcPost(params: {

    /**
     * Identifiant du Belge
     */
    belgeId: number;

    /**
     * Cotisation d'un Belge hors zone IC
     */
    body: CotisationsBelgesHorsZoneIcDto
  }): Observable<CotisationsBelgesHorsZoneIcDto> {

    return this.cotisationsBelgesHorsZoneIcPost$Response(params).pipe(
      map((r: StrictHttpResponse<CotisationsBelgesHorsZoneIcDto>) => r.body as CotisationsBelgesHorsZoneIcDto)
    );
  }

}
